import useSelector from './useSelector/useSelector';
import { getSoftDeployAccessFromState } from './featureHelper';
import { RootState } from 'Store/index';

/**
 * May this session author Pages?
 *
 * Either the account has the `AGENT_PAGES` flag, or this is a consultant session
 * — master's "log in to this account" (WEB-10012) — which is how we build a Page
 * inside a customer's own tenant, with their real data, without switching the
 * feature on for their users.
 *
 * This answers AUTHORING only. Whether a *published* page is visible depends on
 * the page's own state, not on this.
 *
 * The state function exists for the callers that aren't function components
 * (the navbar builds its items in a class component), mirroring
 * `getSoftDeployAccessFromState`.
 */
export const canAuthorPagesFromState = (accountSelf: RootState['App']['accountSelf']): boolean =>
	getSoftDeployAccessFromState(accountSelf, 'AGENT_PAGES') || !!accountSelf?.isPowerSession;

const usePagesAuthoringAccess = (): boolean =>
	canAuthorPagesFromState(useSelector(({ App }) => App.accountSelf));

export default usePagesAuthoringAccess;
